import React from 'react';
import { ReactComponent as PlusIcon } from 'components/icons/plus-circle.svg';
import { ServiceTypes } from 'constants/ServiceTypes';
import { useInjection } from 'services/ioc/ioc.react';
import { TaggingStore } from 'stores/Tagging/TaggingStore';
import { Play } from 'models/tagging/Play';
import { LowerLabel, PlaceholderCard, PlaceholderText, PlayListPlaceholder, Span, UpperLabel } from './PlayPlaceholderStyles';

const PlayPlaceholder: React.FC = () => {
  const { playStore } = useInjection<TaggingStore>(ServiceTypes.TaggingStore);

  return (
    <PlayListPlaceholder>
      <PlusIcon onClick={(): Promise<Play> => playStore.createManualPlayOnTopOfTheList()} />
      <PlaceholderText>You can add pitches without data by clicking the icon</PlaceholderText>
      <PlaceholderCard>
        <UpperLabel />
        <Span>2-1</Span>
        <LowerLabel />
      </PlaceholderCard>
      <PlaceholderCard>
        <UpperLabel />
        <Span>1-1</Span>
        <LowerLabel />
      </PlaceholderCard>
      <PlaceholderText>Incoming plays will be displayed here</PlaceholderText>
    </PlayListPlaceholder>
  );
};

export default PlayPlaceholder;
